import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';
import { buildLoginUrl } from '@/lib/redirect';

/**
 * Route guard that requires authentication.
 * Redirects to login if not authenticated, preserving the intended destination via ?redirectTo=.
 */
export function AuthRouteGuard() {
  const { user, isLoading, rolesLoading } = useAuth();
  const location = useLocation();

  if (isLoading || rolesLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    const returnTo = location.pathname + location.search + location.hash;
    return <Navigate to={buildLoginUrl(returnTo)} replace />;
  }

  return <Outlet />;
}
